import React from 'react';
import { useTranslation } from 'react-i18next';
import { Operation } from '../../Transactions.types';
import { OperationRow } from '../OperationRow';
import * as S from './OperationsTable.styles';

interface OperationsTableProps {
  operations: Operation[];
  onShowDetails: (operation: Operation) => void;
}

export function OperationsTable({
  operations,
  onShowDetails,
}: OperationsTableProps) {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Header>
        <S.HeaderCell>{t('pages.cabinet.ads')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.service')}</S.HeaderCell>
        <S.HeaderCell>{t('common.sum')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.source')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.date')}</S.HeaderCell>
        <S.HeaderCell />
      </S.Header>

      {operations.map(operation => (
        <OperationRow
          key={operation.id}
          operation={operation}
          onShowDetails={onShowDetails}
        />
      ))}
    </S.Container>
  );
}
